export default __webpack_public_path__ + "static/media/empty_human.abd9f40f.png";